'use strict';

export default {
  devStoreConfig: false,
  api: {
    default: 'https://damp-wave-99964.herokuapp.com/v0',
  },
  features: {
    Ledger: false,
    BTC: false,
    BOT: false,
    Ebay: false,
    balanceSelling: false,
  }
};



// WEBPACK FOOTER //
// ./config/config.client6.js